import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc9dbe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "membership",
  tabindex: "-1",
  "aria-labelledby": "membership",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title fw-bold text-center w-100"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title fw-bold text-center w-100"
}
const _hoisted_7 = { class: "py-4 border-bottom" }
const _hoisted_8 = { class: "text-center fs-7" }
const _hoisted_9 = {
  id: "content-scroll",
  class: "overflow-auto text-scroll fs-7 terms p-4 mx-5 my-5 text-break break-spaces"
}
const _hoisted_10 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import dayjs from 'dayjs'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      id: '',
      date: '',
      content: '',
    }),
  },
  title: String,
},
  setup(__props) {

const route = useRoute()



const resetContent = () => {
  let element = document.querySelector('#content-scroll')
  element.scrollTop = 0
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_unref(route).params?.id)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(__props.data?.term_of_service ? (__props.title ? 'YELLoop注意事項' : 'コミュニティ利用注意事項') : 'YELLoop会員規約'), 1))
            : _createCommentVNode("", true),
          (_unref(route).params?.id)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(__props.data?.term_of_service || __props.title ? (__props.title ? 'YELLoop利用規約 ' : 'コミュニティ利用注意事項') : 'YELLoop会員規約'), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: resetContent
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, "Ver." + _toDisplayString(__props.data?.version) + " " + _toDisplayString(_unref(translate)('CD40updated')) + _toDisplayString(_unref(dayjs)(__props.data?.created_at).format('YYYY/MM/DD HH:mm:ss')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data?.term_of_service || __props.data?.content), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            className: 'fw-bold',
            "data-bs-dismiss": "modal",
            onClick: resetContent
          }, null, 8, ["title"])
        ])
      ], 512), [
        [_directive_click_outside, resetContent]
      ])
    ])
  ]))
}
}

})